define([
	"dojo/_base/declare",
	"csi/heading/_base",
	"csi/heading/RefImage",
	"csi/image/_base"
], function(declare,headingBase,RefImage,imageBase) {

	return declare(RefImage, {
		/**
		 * @override
		 * Tooltips only appear when images are represented as icons - in that case return 1 so tooltip shows immediately
		 */
		getTooltipParams: function(ctx, h, refNode) {
			const params = this.inherited(arguments);
			params.delay = 1;
			return params;
		},

		_getImageSrc: function(/*Context*/ctx, /*Heading*/h, /*String*/idImage) {
			// summary: return href for image
			var	node = this._getImageNode(ctx, h);
			return node && imageBase.getImageSrc(node, null, idImage);
		},

		_getTooltipActions: function(/*Context*/ctx, /*Heading*/h, /*Boolean*/bBrowse) {
			// summary: do not allow any actions on snapshot tooltip
			return null;
		},

		_onImageLoad: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/img) {
			// summary: if using icon to render image, then mark node so tooltips will work
			this.inherited(arguments);

			if (img.tagName.toLowerCase() == "div") {
				headingBase.markHeadingNode(img, h, ctx);
			}
		}
	});
});